import * as React from 'react';

import classNames from 'classnames';

import { Icon } from '@base/components';

import { IconLogoMyWorld } from '@icons';

import { ILogoProps } from './types';

import s from './Logo.scss';

export const Logo = (props: ILogoProps) => {
	const { className, src } = props;

	return (
		<a href='/' className={classNames(s.logo, className)}>
			{src
				? <img className={s.logoIcon} src={src} />
				: <Icon className={s.logoIcon} glyph={IconLogoMyWorld}/>}
		</a>
	);
};
